import { render, staticRenderFns } from "./V2Table.vue?vue&type=template&id=31cf0959&scoped=true&"
import script from "./V2Table.vue?vue&type=script&lang=babel&"
export * from "./V2Table.vue?vue&type=script&lang=babel&"
import style0 from "./V2Table.vue?vue&type=style&index=0&id=31cf0959&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf0959",
  null
  
)

export default component.exports